import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Firebase config and core app initialization first (needed before messaging)
const firebaseConfig = {
    apiKey: "AIzaSyCv8wBhinEh5ruAog76u4etEqIr280nn5s",
    authDomain: "zylen-app.firebaseapp.com",
    databaseURL: "https://zylen-app-default-rtdb.firebaseio.com",
    projectId: "zylen-app",
    storageBucket: "zylen-app.firebasestorage.app",
    messagingSenderId: "98546189821",
    appId: "1:98546189821:web:c29b5b0e7c38062c5a8594",
    measurementId: "G-QEM0KT0GQF"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Messaging related exports (initialized later if environment supports it)
let messaging = null;

// Default no-op exports (will be reassigned once messaging is loaded)
let requestNotificationPermission = async () => null;
let onMessageListener = () => { };

// Conditionally (and lazily) load messaging without top-level await
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
    import("firebase/messaging")
        .then(({ getMessaging, getToken, onMessage }) => {
            try {
                messaging = getMessaging(app);

                requestNotificationPermission = async () => {
                    try {
                        if (typeof Notification !== "undefined") {
                            if (Notification.permission === "denied") {
                                console.warn("⚠️ Notification permission is blocked in browser settings");
                                return null;
                            }

                            if (Notification.permission === "default") {
                                const permission = await Notification.requestPermission();
                                if (permission !== "granted") {
                                    return null;
                                }
                            }
                        }

                        const token = await getToken(messaging, {
                            vapidKey: "BLGXoc_PO4wcnejuGMIrzIH-GXy4kefb3gNVtlIhg_aRSyBEXCeM7s_8krXloI5JwjhGqeK3eTCyjw8Fn7-94uk"
                        });
                        return token;
                    } catch (err) {
                        console.error("❌ Error getting FCM token:", err);
                        return null;
                    }
                };

                onMessageListener = (callback) => onMessage(messaging, callback);
            } catch (err) {
                console.warn("⚠️ Failed to initialize Firebase messaging:", err);
            }
        })
        .catch(() => {
            console.warn("⚠️ Firebase messaging not available in this environment");
        });
}

export { messaging, requestNotificationPermission, onMessageListener };